import { phoneTypes } from '@ringcentral-integration/commons/enums/phoneTypes';

export default {
  [phoneTypes.business]: 'Business Phone',
  [phoneTypes.extension]: 'Extension Number',
  [phoneTypes.home]: 'Home Number',
  [phoneTypes.mobile]: 'Mobile Phone',
  [phoneTypes.phone]: 'Phone',
  [phoneTypes.unknown]: 'Unknown Phone Type',
  [phoneTypes.company]: 'Company Number',
  [phoneTypes.direct]: 'Direct Number',
  [phoneTypes.contact]: 'Contact Phone',
  [phoneTypes.fax]: 'Fax',
  [phoneTypes.other]: 'Other',
};
